import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const dynamicBottomNavSelector = createSelector(testTargetOffersSelector, offers => offers.dynamicBottomNav || Empty.Object);

export { dynamicBottomNavSelector };
